import React, {useEffect} from "react";
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {makeStyles} from '@mui/styles';
import {ItemsListMenuDto} from "../../../../../../../../dtos";
import {MenuItem} from "react-contextmenu";
import styles from './menuForItem.module.scss';
import {useTypedSelector} from "../../../../../../../../hooks/useTypeSelector";


const useStyles = makeStyles((theme) => ({
    popper: {
        zIndex: 10,
    },
    paper: {
        borderRadius: '5px',
        margin: '0 5px',
        border: '1px solid #B3B3B3'

    },
    list: {
        padding: 0,
        // marginTop: '5px'
    },
    root: {
        fontSize: '14px',
        height: '30px',
        justifyContent: 'space-between'
    }

}));

interface Props {
    list: ItemsListMenuDto,
    makeUnlinkTargetItem?: () => void;
    isUnlinkItem?: boolean;
    deleteUnlinkItemsFromFlyer?: (isOpen: boolean) => void;
    targetItemsLength?: number;
    onCreateNewItem?: any;
    onEditExistItem?: (e: React.MouseEvent<HTMLElement>) => void;
    isUnlinkPromo?: boolean;
    unlinkAllItemFromPromoSelectedPromo?: () => void;
}


export const MenuForItems = (props: Props) => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const classes = useStyles();

    const handleClose = (event: any) => {
        if (props.list.anchorRef.current && props.list.anchorRef.current.contains(event.target)) {
            return;
        }

        props.list.setOpen(false);
    };

    function handleListKeyDown(event: any) {
        if (event.key === 'Tab') {
            event.preventDefault();
            props.list.setOpen(false);
        }
    }

    useEffect(() => {
        if (props.list.prevOpen.current && !props.list.open) {
            props.list.anchorRef.current!.focus();
        }

        props.list.prevOpen.current = props.list.open;
    }, [props.list.open]);


    const unlinkItem = (event: any) => {
        handleClose(event);
        if (props.makeUnlinkTargetItem) {
            props.makeUnlinkTargetItem();
        }
    }

    const deleteItems = () => {
        if (props.deleteUnlinkItemsFromFlyer) {
            props.deleteUnlinkItemsFromFlyer(true);
        }
    }

    const addNewItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        props.onCreateNewItem()
    }
    const editItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        props.onEditExistItem!(e);
    }
    const duplicateItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
    }
    const unlinkAllItems = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if(props.unlinkAllItemFromPromoSelectedPromo){
            props.unlinkAllItemFromPromoSelectedPromo();
        }
    }


    return (
        <>
            <Popper open={props.list.open}
                    anchorEl={props.list.anchorRef.current}
                    role={undefined}
                    transition
                    placement={'right-start'}
                    className={classes.popper}
                    modifiers={{
                        preventOverflow: {
                            boundariesElement: "viewport"
                        }
                    }}
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                    >
                        <Paper className={classes.paper}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={props.list.open} id="menu-list-grow"
                                          disablePadding
                                          onKeyDown={handleListKeyDown} className={classes.list}>
                                    {
                                        props.isUnlinkPromo &&
                                        <>
                                            <MenuItem className={`${classes.root}`}>
                                                <button onClick={editItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Edit Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button onClick={unlinkItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Unlink Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button onClick={unlinkAllItems} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Unlink all Items
                                                </button>
                                            </MenuItem>
                                        </>
                                    }

                                    {
                                        props.isUnlinkItem && !props.isUnlinkPromo &&
                                        <>
                                            <MenuItem className={classes.root}>
                                                <button onClick={addNewItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Add new Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={`${classes.root}`}>
                                                <button onClick={editItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Edit Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={`${classes.root}`}>
                                                <button onClick={duplicateItem} className={`optionForPreventEvent ${styles.option}`} disabled={true}>
                                                    Duplicate Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button
                                                    onClick={deleteItems}
                                                    className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>{`Delete ${props.targetItemsLength! > 1 ? 'Items' : 'Item'}`}</button>
                                            </MenuItem>
                                        </>
                                    }
                                    {
                                        !props.isUnlinkItem && !props.isUnlinkPromo &&
                                        <>
                                            <MenuItem className={`${classes.root}`}>
                                                <button onClick={editItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Edit Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button onClick={unlinkItem} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Unlink Item
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button onClick={unlinkAllItems} className={`optionForPreventEvent ${styles.option}`} disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Unlink all Items
                                                </button>
                                            </MenuItem>
                                        </>

                                    }
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}